import React from 'react'
import IconField from './icon-field'
import IconRow from './icon-row'
import DateIconLabel from '../date-icon-label'
import HourDurationIconLabel from '../hour-duration-icon-label'
import LocationIconLabel from '../location-icon-label'
import FacilitatorIconLabel from '../facilitator-icon-label'
import EnrollmentIconLabel from '../enrollment-icon-label'
import useClientLocation from '../../../hooks/use-client-location'
import IconButton from './icon-button'
import isEnrolledToExperience from '../../../utilities/is-enrolled-to-experience'
import useCurrentUser from '../../../hooks/use-current-user'
import Requirements from './requirements'
import DimensionPills from '../../dimensions/pill-list'
import CreditsIconLabel from '../credits-icon-label'

const ExperienceDetailsCard = ({
    experience = {},
    style = {},
    onClick: onDefaultClick,
    //  Disables details click if not enrolled (for conflicts screen)
    disableUnenrollededDetails
}) => {
    const { toExperience } = useClientLocation()
    const { currentUser } = useCurrentUser()
    const isEnrolled = isEnrolledToExperience(currentUser, experience)
    const backgroundColor = isEnrolled ? 'rgb(38, 153, 251)' : 'white'
    const color = isEnrolled ? 'white' : 'rgb(38, 153, 251)'
    const descriptionColor = isEnrolled ? 'white' : 'black'
    const borderColor = isEnrolled ? 'rgb(38, 153, 251)' : 'rgb(38, 153, 251)'

    const onClick = React.useCallback(() => {
        if (disableUnenrollededDetails && !isEnrolled) {
            return
        }
        if (onDefaultClick) {
            onDefaultClick()
        } else {
            toExperience(experience.id)
        }
    }, [onDefaultClick, toExperience, disableUnenrollededDetails, isEnrolled])

    return (
        <div
            style={{
                border: '1px solid',
                borderColor,
                borderRadius: '5px',
                backgroundColor,
                paddingLeft: '30px',
                paddingTop: '10px',
                paddingBottom: '30px',
                color,
                position: 'relative',
                cursor: 'pointer',
                ...style,
            }}
            onClick={onClick}
        >
            <IconButton active={isEnrolled} />
            <div className='ellipsis-overflow' style={{ paddingRight: '65px'}}>
                <strong>
                    {experience.name} {experience.seriesId ? '(Series)' : ''}
                </strong>
            </div>
            <IconRow>
                <IconField  >
                    <FacilitatorIconLabel experience={experience} />
                </IconField>
                <IconField  >
                    <LocationIconLabel experience={experience} />
                </IconField>
            </IconRow>
            <IconRow>
                <IconField  >
                    <DateIconLabel experience={experience} />
                </IconField>
                <IconField  >
                    <HourDurationIconLabel experience={experience} />
                </IconField>
            </IconRow>
            <IconRow>
                <IconField  >
                    <EnrollmentIconLabel experience={experience} />
                </IconField>
                <IconField  >
                    <CreditsIconLabel experience={experience} />
                </IconField>
            </IconRow>
            <div style={{ paddingTop: '10px', color: descriptionColor, paddingBottom: '20px'}} className='three-line-ellipsis'>
                {experience.description}
            </div>

            <div>
                <DimensionPills dimensions={experience.dimensions} />
            </div>

            <div>
                <Requirements experience={experience} />
            </div>
        </div>
    )
}

export default ExperienceDetailsCard